import React from 'react'
import Icon from '@components/atoms/Icon'
import { cleanLabel } from '@helpers/global'

interface SelectedFiltersProps {
  selectedFilters: { [key: string]: string[] }
  onFilterChange: (filter: string, paramName: string) => void
}

const SelectedFilters: React.FC<SelectedFiltersProps> = ({ selectedFilters, onFilterChange }) => {
  return (
    <div>
      {Object.keys(selectedFilters).length > 0 && (
        <div className="flex items-center flex-wrap gap-5">
          {Object.keys(selectedFilters).map((param) =>
            selectedFilters[param].map((filter) => {
              const displayText = param === 'price_range' || param.includes('price')
                ? filter.split('-').map(val => `$${val}`).join(' - ')
                : cleanLabel(filter);
              return (
                <div key={filter} className="flex items-center gap-2 py-2 px-3 bg-gradient-grey">
                  <p className="body-sm text-black">{displayText}</p>
                  <button onClick={() => onFilterChange(filter, param)} type="button">
                    <Icon name="close" className="text-black w-4.5 h-4.5" strokeWidth={1} />
                  </button>
                </div>
              )
            }),
          )}
        </div>
      )}
    </div>
  )
}

export default SelectedFilters
